import { render, staticRenderFns } from "./IconGoogleChevronRight.vue?vue&type=template&id=07bd120d&"
import script from "./IconGoogleChevronRight.vue?vue&type=script&lang=ts&"
export * from "./IconGoogleChevronRight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports